module.exports = __webpack_public_path__ + "static/Cameron Nuckols signature white-b674dc522b3eae07d40901b0f3015bbc.svg";